import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./styles/index.css";
import "./plugins/api";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistedStore } from "./store/store";
import { FrontEndProvider } from "./store/context/frontend-context";
import "./assets/sass/plugins.scss";
import "./assets/sass/style.scss";
import "./assets/sass/style.react.scss";
import { BackendProvider } from "./store/context/backend-context";
import "./service/Translations/i18n";

if (process.env.NODE_ENV === "development") {
  const suppressedWarningPatterns = [
    "componentWillReceiveProps has been renamed",
    "componentWillMount has been renamed",
    "componentWillUpdate has been renamed",
  ];

  const originalWarn = console.warn.bind(console);
  console.warn = (...args) => {
    const message = typeof args[0] === "string" ? args[0] : "";
    if (suppressedWarningPatterns.some((pattern) => message.includes(pattern))) {
      return;
    }
    originalWarn(...args);
  };
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
      // console.log('Service Worker kayıtlı:', registration);
    }).catch(function(error) {
      console.log('Service Worker kaydı başarısız:', error);
    });
  });
}


ReactDOM.render(
  <React.Suspense fallback="loading">
    <Provider store={store}>
      <FrontEndProvider>
        <BackendProvider>
          <PersistGate loading={null} persistor={persistedStore}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </PersistGate>
        </BackendProvider>
      </FrontEndProvider>
    </Provider>
  </React.Suspense>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
